import ControllerTable from "./ControllerTable";
import FacilityForm from "./FacilityForm";
import TariffTable from "./TariffTable";

function FacilityView({  facility }) {
	return (
		<>
			<FacilityForm
				facility={facility}
			/>
			<ControllerTable
				facility={facility}
			/>
			<TariffTable
				facility={facility}
			/>
		</>
	);
}

export default FacilityView;
